import React from "react";
import { Helmet } from "react-helmet";

const Head = ({ ...props }) => {
  return (
    <Helmet>
      <title>RingRemind Admin</title>
    </Helmet>
  );
};
export default Head;
